import { useState } from "react";
import ArrowUpSvg from "../../assets/taiga-uikit/icons/arrow-up-1.svg?react";
import { _size } from "../../core/core";
import { DropdownItem } from "../DropdownItem/DropdownItem";
import "./Dropdown.css";

const Dropdown = ({
  size = _size.M,
  mobile = false,
  selected = null,
  options,
  onSelect,
  ...props
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(selected);
  const [animationComplete, setAnimationComplete] = useState(false);
  const toggleDropdown = () => {
    if (!isOpen == true) {
      console.log();
      setAnimationComplete(false);
    }
    setIsOpen(!isOpen);
  };

  const handleOptionSelect = (option) => {
    setSelectedOption(option);
    onSelect(option.id);
    setIsOpen(false);
  };
  const getStyle = () => {
    if (mobile) return `dropdown dropdown-${size} dropdown-mob`;
    else return `dropdown dropdown-${size} `;
  };

  return (
    <button className={getStyle()} onClick={() => toggleDropdown()}>
      <div className={`dropdown-field arrow-down-${isOpen}`}>
        <div className="dropdown-content">
          <div className="dropdown-content-left">
            {props.children || selectedOption.label}
          </div>
          <ArrowUpSvg></ArrowUpSvg>
        </div>
        {animationComplete !== true && isOpen && (
          <div
            className={`dropdown-items dropdown-open-${isOpen}`}
            onAnimationEnd={() => {
              console.log(isOpen);
              if (!isOpen) {
                // Если блок закрыт (isOpen === false), скрыть его после анимации.
                setAnimationComplete(true);
              }
            }}
          >
            {options.map((option) => (
              <DropdownItem
                size={size}
                onClick={() => handleOptionSelect(option)}
                option={option}
              ></DropdownItem>
            ))}
          </div>
        )}
      </div>
    </button>
  );
};

export default Dropdown;
